<template>
	<div class="pt-2">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<MultipleLineGanttChart
				:taskTitle="'工事項目'"
				:tasks="constructionProcesses"
				:taskNameKey="'name'"
				:startDateKey="startDateKey"
				:endDateKey="endDateKey"
				:fontSize="fontSize"
				:taskBarStyle="taskBarStyle"
				:taskBarNameStyle="taskBarNameStyle"
				:colorRecognitionKey="'situation'"
				:taskBarColorsByRecognitionKey="taskBarColorsByRecognitionKey"
				:taskBarType="'bar'"
				:changeDatetimeFlag="authority_flag"
        :darkColorUntil="start_date"
        :darkColorFrom="planned_end_date"
				showDates
				showCells
				onlyDateChartType
				@change-datetime="changeDatetime($event)"
			>
				<template v-slot:top-section>
					<v-form v-model="valid">
						<v-row no-gutters justify="space-between" align="baseline">
							<v-row no-gutters align="baseline">
								<v-menu
									ref="menu"
									close-on-content-click
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											label="開始日(必須)"
											:rules="[rules.required]"
											class="mr-2 mt-2"
											v-model="start_date"
											outlined
											dense
											readonly
											v-bind="attrs"
											v-on="on"
										/>
									</template>
									<v-date-picker v-model="start_date" no-title scrollable locale="ja" />
								</v-menu>
								<v-menu
									ref="menu"
									close-on-content-click
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											label="終了予定日(必須)"
											class="mt-2"
											:rules="[rules.required]"
											v-model="planned_end_date"
											outlined
											dense
											readonly
											v-bind="attrs"
											v-on="on"
										/>
									</template>
									<v-date-picker v-model="planned_end_date" no-title scrollable locale="ja" />
								</v-menu>
							</v-row>
							<v-row no-gutters justify="end" align="baseline">
								<div
									v-for="(situation, i) in situations"
									class="px-1 text-body-2 mt-sm-0 mt-2"
									:key="i"
								>
									<span :style="{ color: taskBarColorsByRecognitionKey[situation.id] }"> ● </span>
									{{ situation.name }}
								</div>
								<v-btn class="ml-2 mt-sm-0 mt-2" color="secondary" @click="setCost"
									>原価見積から項目インポート</v-btn
								>
								<v-btn
									class="ml-2 mt-sm-0 mt-2"
									color="secondary"
									:disabled="!valid"
									@click="saveChangedProcesses"
									>変更を保存する</v-btn
								>
							</v-row>
						</v-row>
					</v-form>
				</template>
			</MultipleLineGanttChart>
			<ConstructionProcessNewDialog
				:construction_process_types="construction_process_types"
				@add-process="addConstructionProcess($event)"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import MultipleLineGanttChart from "../shared/MultipleLineGanttChart.vue"
import ConstructionProcessNewDialog from "./components/ConstructionProcessNewDialog.vue"
import PaginationModule from "../../modules/PaginationModule.vue"

export default {
	components: {
		CommonFlame,
		MultipleLineGanttChart,
		ConstructionProcessNewDialog,
		PaginationModule,
	},
	data() {
		return {
			title: "工事工程表",
			id: this.$route.params.id,
			constructionProcesses: [], // モデル名不明のためconstruction_processes
			construction_process_types: [], // モデル名不明…
			situations: [],
			authority_flag: false,
			valid: false,
			start_date: '2023-05-01',
			planned_end_date: '2023-05-31',
			fontSize: "14px",
			taskBarStyle: {
				textAlign: "center",
				height: "24px",
				paddingBottom: "4px",
				borderRadius: 0,
			},
			taskBarNameStyle: {
				fontSize: ".9rem",
				color: "black",
			},
			startDateKey: "start_date",
			endDateKey: "end_date",
			taskBarColorsByRecognitionKey: {
				planned: this.$vuetify.theme.themes.light.rubber_process.requested,
				ongoing: this.$vuetify.theme.themes.light.rubber_process.ongoing,
				completed: this.$vuetify.theme.themes.light.rubber_process.completed,
			},
			changedProcesses: [],
			dialog: false,
			common,
			rules,
		}
	},

	mounted() {
		this.fetchConstructions()
	},
	methods: {
		fetchConstructions() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/constructions/constructions/:id/construction_processes", {
					headers,
				})
				.then((res) => {
					this.construction = res.data.construction
					this.construction_process_types = res.data.construction_process_types
					this.constructionProcesses = res.data.construction_processes
					this.costs = res.data.costs // TODO 原価見積のモデルに名前変更
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmSave(event) {
			event.returnValue = "変更したデータは保存されませんが、よろしいですか？"
		},
		changeDatetime(newProcess) {
			let params

			// 全てを表示している場合は適当した日時を絞り込む
			params = {
				[this.startDateKey]: newProcess[this.startDateKey],
				[this.endDateKey]: newProcess[this.endDateKey],
				id: newProcess.id,
			}
			let oldParams = this.changedProcesses.find((p) => p.id == params.id)
			if (oldParams) {
				let paramsIndex = this.changedProcesses.indexOf(oldParams)
				Object.keys(params).forEach((key) => {
					oldParams[key] = params[key]
				})
				this.changedProcesses[paramsIndex] = oldParams
			} else {
				this.changedProcesses.push(params)
			}

			let process = this.constructionProcesses.find((p) => p.id == params.id)
			if (!process) return
			Object.keys(params).forEach((key) => {
				process[key] = params[key]
			})
			let index = this.constructionProcesses.indexOf(process)
			this.constructionProcesses[index] = process
			window.addEventListener("beforeunload", this.confirmSave)
		},

		setCost() {
			// TODO
		},
		saveChangedProcesses() {
			// TODO
			const headers = authenticate.setHeader()
			const url = ``
			axios
				.put(
					url,
					{ rubber_processes: this.changedProcesses },
					{
						headers,
					}
				)
				.then((res) => {
					res.data.forEach((process) => {
						this.updateRubberProcess(process)
					})
					this.changedProcesses = []
					window.removeEventListener("beforeunload", this.confirmSave)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addConstructionProcess(process) {
			// TODO
		},
	},
	computed: {
		destroyed() {
			window.removeEventListener("beforeunload", this.confirmSave)
		},
		beforeRouteLeave(to, from, next) {
			if (!this.changedProcesses.length) {
				window.removeEventListener("beforeunload", this.confirmSave)
				next()
				return
			}
			const answer = window.confirm("変更したデータは保存されませんが、よろしいですか？")
			if (answer) {
				window.removeEventListener("beforeunload", this.confirmSave)
				next()
			} else {
				next(false)
			}
		},
	},
}
</script>
